import { PaperProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus, useAdminInvoiceQuery } from '../../../../api/gql';
import { InvoiceStatusInfoBox } from '../../../../components/InvoiceStatusInfoBox';

type Props = {
  invoiceId: string;
} & PaperProps;

export const InvoiceStatusInfoBoxModule = ({ invoiceId, ...rest }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useAdminInvoiceQuery({
    id: invoiceId,
  });
  return (
    <InvoiceStatusInfoBox
      status={data?.adminInvoice?.status ?? InvoiceStatus.Processing}
      isLoading={isLoading}
      errorMessage={isError ? (t('query.error.default') as string) : undefined}
      titleProps={{ variant: 'h2' }}
      {...rest}
    />
  );
};
